// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as DomEl$GameDataCore from "../DomEl.res.mjs";

var scrolledRoots = new WeakMap();

var highlightClasses = [
  "ring-2",
  "ring-primary/50",
  "rounded-md"
];

function addHighlight(target) {
  Belt_Array.forEach(highlightClasses, (function (name) {
          DomEl$GameDataCore.addClass(target, name);
        }));
}

function removeHighlight(target) {
  Belt_Array.forEach(highlightClasses, (function (name) {
          DomEl$GameDataCore.removeClass(target, name);
        }));
}

function scrollIfNeeded(root) {
  var raw = root.getAttribute("data-focus-snippet-id");
  if (raw == null) {
    scrolledRoots.delete(root);
    return ;
  }
  var match = scrolledRoots.get(root);
  if (!(match == null) && match) {
    return ;
  }
  var target = document.getElementById("inbox-snippet-" + raw);
  if (!(target == null)) {
    scrolledRoots.set(root, true);
    target.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
    addHighlight(target);
    setTimeout((function () {
            removeHighlight(target);
          }), 2200);
    return ;
  }
  
}

function mounted() {
  var self = this ;
  var root = self.el;
  scrolledRoots.delete(root);
  scrollIfNeeded(root);
}

function updated() {
  var self = this ;
  scrollIfNeeded(self.el);
}

var inboxSnippetFocus = {
  mounted: mounted,
  updated: updated
};

export {
  scrolledRoots ,
  highlightClasses ,
  addHighlight ,
  removeHighlight ,
  scrollIfNeeded ,
  mounted ,
  updated ,
  inboxSnippetFocus ,
}
/* scrolledRoots Not a pure module */
